import { jsxs as i, jsx as r } from "react/jsx-runtime";
import t from "styled-components";
import o from "../../utils/colors.js";
import n from "../Icons/Tick.js";
import p from "../Text/index.js";
const s = t.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 2px solid ${o.green};
  max-width: 160px;
  height: 50px;

  span {
    color: ${o.green};
  }
`, a = t.div`
  svg {
    width: 20px;
    height: 20px;
    margin-top: 2px;
    margin-right: 10px;
  }
`, l = ({ text: e = "Thank you" }) => /* @__PURE__ */ i(s, { children: [
  /* @__PURE__ */ r(a, { children: /* @__PURE__ */ r(n, {}) }),
  /* @__PURE__ */ r(p.Body, { fontWeight: "bold", as: "span", children: e })
] });
export {
  l as default
};
